import Button from '../ui/Button'
import Icon from '../ui/Icon'

/**
 * NextNumberButton Component
 * Handles next number request functionality
 * Isolated for better testing and reusability
 */
const NextNumberButton = ({ 
  onRequestNext, 
  loading, 
  remainingCalls, 
  cooldownMessage,
  disabled = false
}) => {
  return (
    <div className="text-center pt-2">
      <Button 
        onClick={onRequestNext}
        disabled={loading || disabled}
        className={`px-6 py-2 text-white ${
          disabled 
            ? 'bg-gray-400 cursor-not-allowed' 
            : 'bg-blue-600 hover:bg-blue-700'
        }`}
      >
        {loading ? (
          <>
            <Icon name="loading" className="mr-2 animate-spin" />
            খোঁজা হচ্ছে...
          </>
        ) : (
          <>
            <Icon name="arrow-right" className="mr-2" />
            পরবর্তী নম্বর
          </>
        )}
      </Button>
      
      {cooldownMessage && (
        <div className="mt-2 text-center text-orange-600 text-sm">
          {cooldownMessage}
        </div>
      )}
      
      {remainingCalls === 0 && (
        <div className="mt-2 text-center">
          <div className="text-orange-600 font-medium">
            আজকের সব কল শেষ হয়ে গেছে
          </div>
          <div className="text-sm text-gray-500">
            আগামীকাল আবার চেষ্টা করুন
          </div>
        </div>
      )}
    </div>
  )
}

export default NextNumberButton